import {Wall_eContext} from '@/errors/Wall_e';
import {useContext} from 'react';

export default function useErrorHandler() {
  const wall_e = useContext(Wall_eContext);
  return {handle: wall_e.handle};
}
